import { Route, Switch } from 'wouter';
import { useAuth } from './hooks/use-auth';
import { LoginPage } from './pages/LoginPage';
import { BandsDashboard } from './pages/BandsDashboard';
import { BandHome } from './pages/BandHome';
import { SongLibrary } from './pages/SongLibrary';
import { SongDetail } from './pages/SongDetail';
import { ChartEditorPage } from './pages/ChartEditorPage';
import { MyCharts } from './pages/MyCharts';
import { SetlistsPage } from './pages/SetlistsPage';
import { SetlistDetailPage } from './pages/SetlistDetailPage';
import { SetlistViewPage } from './pages/SetlistViewPage';
import { BandSettings } from './pages/BandSettings';
import { RehearsalNotesPage } from './pages/RehearsalNotesPage';

export default function App() {
  const { user, isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <div className="h-full flex items-center justify-center bg-surface-950">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-primary-400 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-sm text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <Switch>
      <Route path="/" component={BandsDashboard} />
      <Route path="/bands/:bandId" component={BandHome} />
      <Route path="/bands/:bandId/songs" component={SongLibrary} />
      <Route path="/bands/:bandId/songs/:songId" component={SongDetail} />
      <Route path="/bands/:bandId/notes" component={RehearsalNotesPage} />
      <Route path="/bands/:bandId/setlists" component={SetlistsPage} />
      <Route path="/bands/:bandId/setlists/:setlistId/view" component={SetlistViewPage} />
      <Route path="/bands/:bandId/setlists/:setlistId" component={SetlistDetailPage} />
      <Route path="/bands/:bandId/settings" component={BandSettings} />
      <Route path="/editor/:type/:chartId" component={ChartEditorPage} />
      <Route path="/my-charts" component={MyCharts} />
      <Route>
        <div className="h-full flex items-center justify-center bg-surface-950 text-gray-400">Page not found</div>
      </Route>
    </Switch>
  );
}
